import { render } from "./RFIEmptyState.vue?vue&type=template&id=273a1d3f"
import script from "./RFIEmptyState.vue?vue&type=script&lang=js"
export * from "./RFIEmptyState.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__